import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';


const columnData = (statusCode, flag) => {
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={2}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th>설비번호</th>,
      td: (props) => {
        return <td>{props.areaNo}</td>;
      },
    },
    areaNm: {
      colWidth: '300px',
      th: <th>설비명</th>,
      td: (props) => {
        return <td>{props.areaNm}</td>;
      },
    },
    modelNo: {
      colWidth: '300px',
      th: <th rowSpan={2}>감지기No.</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    h2s: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          pH
        </th>
      ),
      td: (props) => {
        return (props.h2s === -1 ? <td>-</td> : statusCode === '0' ? props.moduleScn === '0' ?
          <td className={classNames('data-text', props.h2s_status)}>
            {props.h2s.toFixed(1)}
          </td> : <td>-</td> : <></>)
      },
    },
    status: {
      colWidth: '130px',
      th: <th rowSpan={2}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <td></td>)
      },
    },
    battery: {
      colWidth: '130px',
      th: <th rowSpan={2}>Battery잔량</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={2}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
